import { slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { Button } from '../Button/component.js';
import { IconButton } from '../IconButton/component.js';
import { Label } from '../Label/component.js';
import { withTooltip } from '../../hoc/with-tooltip.js';

var ToggleButton = function ToggleButton(props) {
  /**
   * State
   */
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1];

  var _useState3 = useState(!!props.isActive),
      _useState4 = _slicedToArray(_useState3, 2),
      isActive = _useState4[0],
      setIsActive = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      iconName = _useState6[0],
      setIconName = _useState6[1];
  /**
   * Hooks
   */


  useEffect(function () {
    setLabel(props.isToggled ? props.beforeLabel : props.afterLabel);
    setIsActive(!isActive);
    props.isToggled && props.beforeLabel.type === 'iconOnlyLabel' && props.beforeLabel.options.icon.iconName ? setIconName(props.beforeLabel.options.icon.iconName) : props.afterLabel.type === 'iconOnlyLabel' && props.afterLabel.options.icon.iconName ? setIconName(props.afterLabel.options.icon.iconName) : null;
  }, [props]);
  /**
   * DOM
   */

  var btnProps = {
    'aria-label': props.ariaLabel || 'Toggle Button',
    isActive: isActive
  };

  if (props.beforeLabel.type === 'iconOnlyLabel' && props.afterLabel.type === 'iconOnlyLabel') {
    return /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        var _props$onToggled;

        (_props$onToggled = props.onToggled) === null || _props$onToggled === void 0 || _props$onToggled.call(props, !props.isToggled);
      },
      icon: {
        iconName: iconName
      },
      isActive: isActive,
      ariaLabel: btnProps['aria-label'],
      tooltip: props.tooltip
    });
  }

  return /*#__PURE__*/React.createElement(Button, _extends({}, btnProps, {
    tooltip: props.tooltip,
    onClick: function onClick() {
      var _props$onToggled2;

      (_props$onToggled2 = props.onToggled) === null || _props$onToggled2 === void 0 || _props$onToggled2.call(props, !props.isToggled);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: label !== null && label !== void 0 ? label : props.beforeLabel
  }));
};

ToggleButton.displayName = "ToggleButton";
ToggleButton.displayName = 'ToggleButton';
var component = withTooltip('ToggleButton')(ToggleButton);
export { ToggleButton, component as default };